import { useAuth } from '../../contexts/AuthContext';
import { getRoleDisplayName, roleColors, type UserRole } from '../../utils/roleColors';
import { 
  Shield, 
  Scale, 
  User, 
  Gavel, 
  Settings,
  Sparkles
} from 'lucide-react';

const roleIcons: Record<UserRole, typeof Shield> = {
  LawEnforcement: Shield,
  Attorney: Scale,
  PublicSubmitter: User,
  CaseManager: Gavel,
  SystemAdmin: Settings,
  Judge: Gavel,
};

const roleTitles: Record<UserRole, string> = {
  LawEnforcement: 'Metro Police - Major Crimes',
  Attorney: 'District Attorney\'s Office',
  PublicSubmitter: 'Public Portal',
  CaseManager: 'Court Clerk\'s Office',
  SystemAdmin: 'IT Administration',
  Judge: 'Superior Court',
};

export function PersonaIndicator() {
  const { user } = useAuth();

  if (!user) return null;

  const role = user.role as UserRole;
  const colors = roleColors[role];
  const Icon = roleIcons[role];
  const label = role === 'LawEnforcement'
    ? 'Detective'
    : role === 'PublicSubmitter'
      ? 'Citizen'
      : getRoleDisplayName(role, user.department);
  const title = user.department || roleTitles[role];

  return (
    <div className={`flex items-center gap-3 px-4 py-2 rounded-xl ${colors.bg} ${colors.border} border-2 shadow-sm`}>
      {/* Animated indicator */}
      <div className="relative">
        <div className={`p-2 rounded-lg ${colors.solid}`}>
          <Icon className="h-5 w-5 text-white" />
        </div>
        <span className="absolute -top-1 -right-1">
          <Sparkles className="h-3 w-3 text-amber-500 animate-pulse" />
        </span>
      </div>
      
      {/* User info */}
      <div className="flex flex-col">
        <div className="flex items-center gap-2">
          <span className={`font-bold ${colors.text}`}>{user.name}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${colors.badge}`}>
            {label}
          </span>
          <span className="text-xs text-gray-500 hidden xl:inline">
            {title}
          </span>
        </div>
      </div>
    </div>
  );
}

export default PersonaIndicator;
